import { AddCreditsForReferralModelRequest, CreditData } from "../../models/credits/CreditsModels";
import httpClient from "../../utilities/http-client";

export const addCreditsForReferral = async (model: AddCreditsForReferralModelRequest) => {
	try {
		const { data } = await httpClient.post(`/credits/add/referral/`, model);
		return data;
	} catch (e: any) {
		throw  e;
	}
};

export const getCreditsList = async (from:number, count:number, last?:boolean) => {
	try{
		const params = new URLSearchParams();
		if (last !== null && last !== undefined) params.append("last", last.toString());

		const queryString = params.toString();
		const url = `/credits/list/${from}/${count}/` + (queryString ? `?${queryString}` : "");

		const { data } = await httpClient.get<CreditData>(url);
		return data;
	}catch(e:any){
		throw e;
	}
}
